import React, {useState} from 'react';
import PropTypes from 'prop-types';
import RegionalSettingModal from 'components/authentication/RegionalSettingModal';
import currencySymbol from 'lib/helpers/currency-symbol-map';
import GlobeIcon from 'components/navbar/icons/GlobeIcon';
import CoinsIcon from 'components/navbar/icons/CoinsIcon';
import ChevronDownIcon from 'components/navbar/icons/ChevronDownIcon';

const Localization = ({
  isPreferredCurrencyEnabled,
  locales,
  brandLocale,
  defaultLocale,
  defaultCurrency,
  currencies,
  preferredCurrency,
  preferredLocale,
  translations,
  isSeatingOrPaymentPage
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((isModalOpen) => !isModalOpen);
  };

  return (
    <>
      <div className="navbar-localization-pills" onClick={toggleModal}>
        <button type="button" className="navbar-localization-pills__btn">
          <GlobeIcon />
          <span>{locales[defaultLocale].language}</span>
          <ChevronDownIcon />
        </button>
        {isPreferredCurrencyEnabled && (
          <button type="button" className="navbar-localization-pills__btn navbar-localization-pills__btn--divider">
            <CoinsIcon />
            <span>
              {defaultCurrency}
              {' '}<span className="navbar-localization-pills__dot">&bull;</span>{' '}
              {currencySymbol[defaultCurrency]}
            </span>
            <ChevronDownIcon />
          </button>
        )}
      </div>
      {isModalOpen && (
        <RegionalSettingModal
          locales={locales}
          brandLocale={brandLocale}
          preferredLocale={preferredLocale}
          isPreferredCurrencyEnabled={isPreferredCurrencyEnabled}
          currencies={currencies}
          preferredCurrency={preferredCurrency}
          toggleModal={toggleModal}
          translations={translations}
          isSeatingOrPaymentPage={isSeatingOrPaymentPage}
        />
      )}
    </>
  );
};

Localization.propTypes = {
  locales: PropTypes.object.isRequired,
  currencies: PropTypes.array.isRequired,
  brandLocale: PropTypes.string.isRequired,
  preferredLocale: PropTypes.string.isRequired,
  isPreferredCurrencyEnabled: PropTypes.bool.isRequired,
  defaultLocale: PropTypes.string.isRequired,
  defaultCurrency: PropTypes.string.isRequired,
  preferredCurrency: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  isSeatingOrPaymentPage: PropTypes.bool
};

Localization.defaultProps = {
  isSeatingOrPaymentPage: false
};

export default Localization;
